// extracted by mini-css-extract-plugin
export var offerings = "offerings-module--offerings--1FdeM";
export var accordion = "offerings-module--accordion--3bWRD";
export var section = "offerings-module--section--1r22l";
export var sectionTitleButton = "offerings-module--sectionTitleButton--1v3UY";
export var sectionTitleButtonImg = "offerings-module--sectionTitleButtonImg--2Qwyb";
export var plus = "offerings-module--plus--3I-68";
export var open = "offerings-module--open--XbA3S";
export var sectionContent = "offerings-module--sectionContent--3iVjz";
export var pointsList = "offerings-module--pointsList--QsD_y";
export var pointsItem = "offerings-module--pointsItem--ge6Uo";
export var pointsItemArrow = "offerings-module--pointsItemArrow--2h6oh";
export var pointsItemCopy = "offerings-module--pointsItemCopy--11Y2f";